import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { CountryOutputDTO } from './countryDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class CountryServices {
  async getByAll(params: any): Promise<CountryOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = {...params, limit : 999}
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/country/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getById(id: number): Promise<CountryOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/country/${id}`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const countryServices = new CountryServices()
